import checkout from "./form";

const {
  formField: { domain, username, password, clientId },
} = checkout;

export default {
  [domain.name]: "",
  [username.name]: "",
  [password.name]: "",
  [clientId.name]: "",
};
